<div class="profile-block">
  <div class="menu-button" (click)="routeToWithRefresh('/admin-panel/categories')" *ngIf="currentUser.adminRole"
       (click)="profileOP.hide()">
    <mat-icon>edit</mat-icon>
    <span class="menu-label">Admin Panel</span>
  </div>
  <div class="menu-button" (click)="routeTo('/pricing')" *ngIf="currentUser.adminRole"
       (click)="profileOP.hide()">
    <mat-icon>calculate</mat-icon>
    <span class="menu-label">Pricing</span>
  </div>
  <div class="menu-button" (click)="routeTo('/planning')" *ngIf="currentUser.adminRole"
       (click)="profileOP.hide()">
    <mat-icon>format_list_numbered</mat-icon>
    <span class="menu-label">Production planning</span>
  </div>
  <div class="menu-button" (click)="switchToCartTv(); profileOP.hide()" *ngIf="currentUser.adminRole">
    <mat-icon>shopping_cart</mat-icon>
    <span class="menu-label">Part Sorting</span>
  </div>
  <div class="menu-button" (click)="openEditProfileDialog()">
    <mat-icon>account_circle</mat-icon>
    <span class="menu-label">Profile</span>
  </div>
  <div class="menu-button" (click)="openFeedBackDialog()">
    <mat-icon>feedback</mat-icon>
    <span class="menu-label">Send FeedBack</span>
  </div>
  <div class="menu-button" (click)="openQbAuth()">
    <div class="qb-logo"></div>
    <span class="menu-label">QB Auth</span>
  </div>
  <div class="menu-button" (click)="doLogout()">
    <mat-icon>exit_to_app</mat-icon>
    <span class="menu-label">Logout</span>
  </div>
</div>
